import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.replace.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import delay from 'lodash/delay';
import { SLOW_TIMER } from '~/const/timers';
import CategoryFiltersBar from '~/components/templates/Category/CategoryFiltersBar.vue';
import CategoryFiltersList from '~/components/templates/Category/CategoryFiltersList.vue';
import CategorySortsLoading from '~/components/organisms/Category/Loading/CategorySortsLoading.vue';
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
import CategoryProductCount from '~/components/molecules/Category/CategoryProductCount.vue';
import CategorySorts from '~/components/organisms/Category/CategorySorts.vue';
import CategoryProductList from '~/components/organisms/Category/CategoryProductList.vue';
import CategoryStickyButtons from '~/components/organisms/Category/CategoryStickyButtons.vue';
import CategoryLayer from '~/components/organisms/Category/CategoryLayer.vue';
import CommercialBanner from '~/components/atoms/Global/CommercialBanner.vue';
import MdmInfiniteScroll from '~/components/atoms/Global/MdmInfiniteScroll.vue';
import MdmPagination from '~/components/atoms/Global/MdmPagination.vue';
var PRODUCTS_PER_PAGE = 40;
export default {
  name: 'CategoryTemplate',
  components: {
    CategoryFiltersBar,
    CategoryFiltersList,
    CategorySortsLoading,
    CategoryProductCount,
    CategoryProductListLoading,
    CategorySorts,
    CategoryProductList,
    CategoryStickyButtons,
    CategoryLayer,
    CommercialBanner,
    MdmInfiniteScroll,
    MdmPagination
  },
  props: {
    serverFetch: {
      type: Boolean,
      default: false
    },
    nextPage: {
      type: Number,
      required: true
    },
    loadingNextPage: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      default: false
    },
    previousPage: {
      type: Number,
      required: true
    },
    loadingPreviousPage: {
      type: Boolean,
      default: false
    },
    currentPath: {
      type: String,
      required: true
    },
    description: {
      type: Object,
      required: true
    },
    breadcrumb: {
      type: Array,
      required: true
    },
    productsCount: {
      type: Number,
      required: true
    },
    filters: {
      type: Array,

      default() {
        return null;
      }

    },
    selectedFilters: {
      type: Array,
      required: true
    },
    algolia: {
      type: Boolean,
      default: false
    },
    isCategoryTemplate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedLayer: null,
      stickyFilters: {
        cookie: 'category-sticky-buttons',
        selectedFilterLayer: null,
        isLimitReached: null,
        lastPosY: null,
        scrollPosY: null
      }
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    seeResultsLabel() {
      return "".concat(this.$t('see-results'), " (").concat(this.productsCount, ")");
    },

    paginationTracking() {
      return {
        data: {
          event_category: 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },

    infiniteFrom() {
      return this.nextPage * PRODUCTS_PER_PAGE;
    },

    progressMsg() {
      var x = this.infiniteFrom < this.productsCount ? this.infiniteFrom : this.productsCount;
      return this.$t('message', {
        x,
        y: this.productsCount
      });
    },

    activeStickyFilters() {
      return Boolean(this.$cookies.get(this.stickyFilters.cookie));
    }

  }),

  mounted() {
    this.$root.$on('sticky-filters', type => {
      this.handleOpenLayer(type);
    });
    this.listenMatchMedia('DESKTOP', () => {
      delay(() => {
        this.open = false;
        this.enableWindowScroll();
      }, SLOW_TIMER);
    });
    this.bindScrollListener();
  },

  beforeDestroy() {
    this.enableWindowScroll();
  },

  destroyed() {
    this.unbindScrollListener();
  },

  methods: _objectSpread(_objectSpread({}, mapMutations({
    resetFilters: 'pageActions/RESET_FILTERS'
  })), {}, {
    reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },

    bindScrollListener() {
      window.addEventListener('scroll', this.handleScrollOnce, {
        once: false,
        passive: true
      });

      if (this.activeStickyFilters) {
        window.addEventListener('scroll', this.handleStickyFilters);
      }
    },

    unbindScrollListener() {
      window.removeEventListener('scroll', this.handleScrollOnce);

      if (this.activeStickyFilters) {
        window.removeEventListener('scroll', this.handleStickyFilters, {
          once: false,
          passive: true
        });
      }
    },

    handleScrollOnce() {
      if (!this.activeStickyFilters) {
        this.unbindScrollListener();
      }
    },

    handleOpenLayer(layer) {
      this.disableWindowScroll();
      this.selectedLayer = layer;
    },

    handleCloseLayer() {
      this.enableWindowScroll();
      this.selectedLayer = null;
    },

    handleStickyFilters() {
      var {
        scrollY: currentScrollY
      } = window;
      var {
        buttonFilters
      } = this.$refs;
      var scrollUp = currentScrollY <= this.stickyFilters.lastPosY;
      var bannerHeight = 64;
      var relativeScrollY = currentScrollY + bannerHeight;
      var scrollReachedLimit = relativeScrollY > buttonFilters.offsetTop;
      this.stickyFilters.isLimitReached = scrollReachedLimit;
      this.$root.$emit('sticky-filters-button', scrollReachedLimit, scrollUp);
      this.stickyFilters.lastPosY = currentScrollY;
    },

    formatUrl(url) {
      return url.replace(':market', this.locale.market).replace(':language', this.locale.language);
    }

  })
};